import { OBSIDIAN } from 'HubStyleTokens/colors';
import UITruncateString from 'UIComponents/text/UITruncateString';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedPhoneNumber from 'I18n/components/FormattedPhoneNumber';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledUITruncateString = styled(UITruncateString).withConfig({
  displayName: "ContactDetail__StyledUITruncateString",
  componentId: "pcyx3f-0"
})(["line-height:16px;margin-bottom:10px;color:", ";font-weight:500;font-size:16px;"], OBSIDIAN);
const isPhoneNumber = contactDetail => !isNaN(Number(contactDetail));
const ContactDetail = ({
  contactDetail,
  isKnownContact
}) => {
  return /*#__PURE__*/_jsx(StyledUITruncateString, {
    children: isKnownContact ? isPhoneNumber(contactDetail) ? /*#__PURE__*/_jsx(FormattedPhoneNumber, {
      value: contactDetail
    }) : contactDetail : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.header.unknownVisitorLabel"
    })
  });
};
ContactDetail.displayName = 'ContactDetail';
export default ContactDetail;